import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CategoryApplicationsEffects } from './category-applications.effects';
import { categoryApplicationsReducer } from './category-applications.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('categoryApplications', categoryApplicationsReducer),
    EffectsModule.forFeature([CategoryApplicationsEffects]),
  ],
  providers: [],
})
export class CategoryApplicationsStoreModule {}
